// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__qCckN","mainGrid":"styles_mainGrid__3khm5","dependentsGrid":"styles_dependentsGrid__1Zu8J","secondGrid":"styles_secondGrid__20B2l"};